import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/identity-number'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };
  return {
    html,
    validators: [
      function (state) {
        if (state.error) {
          return 'error';
        }
        return false;
      },
    ],
    config: {
      behaviour: 'text-input',
    },
  };
}
